import "@mdi/font/css/materialdesignicons.css";
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: "mdi",
    theme: {
        themes: {
            light: {
                primary: "#21B17E",
                secondary: "#21B17E",
                accent: "#8c9eff",
                error: "#b71c1c",
                barraSuperior: "#1EB27E",
                barraText: "white--text",
                buttonText: "white--text"
            }
        }
    },
    lang: {
        locales: {
            pt
        },
        current: "pt"
    }
});